import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class RugbyLeagueHomePage extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="rugby-league"
      title="Rugby League Scores, Fixtures & Results"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/RugbyLeague/containers/RugbyLeagueHomePage.js